import FormBuilderOb from '@components/FormBuilder/FormBuilder.ob';
import { Box, LuxCheckbox, LuxTypography, useTheme } from '@gemini/fe-ds-core';
import { FormIds } from '@utils/enums/FormIds.enum';
import {
  CheckBoxWrapper,
  ContactDetailsWrapper,
} from './ContactDetailsPage.styles';
import { usePatientStore } from '@store/patientStore';
import { useOnlineBookingStore } from '@store/onlineBookingStore';
import { StaticValues } from '@utils/enums/StaticValues.enum';
import { useEffect, useMemo } from 'react';
import useAnalytics from '@hooks/useAnalytics';
import { FlowsPages } from '@utils/enums/FlowsPages.enum';
import { useTranslation } from 'react-i18next';

interface ContactDetailsProps {
  setEnableButton: (val: boolean) => void;
}

const ContactDetailsPage = ({ setEnableButton }: ContactDetailsProps) => {
  const { trackPageAnalytics } = useAnalytics();
  const { t } = useTranslation();
  const theme = useTheme();
  const updateContactDetils = usePatientStore(
    state => state.updateContactDetils,
  );
  const formConfigs = useOnlineBookingStore(state => state.formConfigs);

  const brandName = useOnlineBookingStore(state => state.brandName);
  const setCheckboxValue = useOnlineBookingStore(
    state => state.setContactDetailsCheckboxStatus,
  );
  const checkboxValue = useOnlineBookingStore(
    state => state.contactDetailsCheckboxStatus,
  );

  const links = useOnlineBookingStore(state => state.links);

  const getPatients = usePatientStore(state => state.getPatients);
  const patients = getPatients();
  const setShouldSave = useOnlineBookingStore(state => state.setShouldSave);

  //ANALYTICS (RONA only) - Review
  useEffect(() => {
    if (!brandName) return;
    const timeout = window.setTimeout(() => {
      trackPageAnalytics({
        page: FlowsPages.CONTACT_DETAILS,
        patients,
      });
    }, 100); // slight delay to ensure we wanted to land here and have not restarted from step 1 (isStartedNewPatient === false)
    return () => window.clearTimeout(timeout);
  }, [brandName, patients, trackPageAnalytics]);

  const handleContactDetailsForm = (e: any) => {
    setCheckboxValue(e.target.checked);
  };

  const formIds = useMemo(() => {
    if (
      formConfigs?.customFieldsMarketing.show &&
      formConfigs?.customFieldsMarketing.children.some(
        c => c.status !== StaticValues.FIELD_STATUS_HIDDEN,
      )
    )
      return [FormIds.ContactInformation, FormIds.CustomFieldsMarketing];
    else return [FormIds.ContactInformation];
  }, [formConfigs]);

  return (
    <ContactDetailsWrapper>
      <CheckBoxWrapper>
        <LuxCheckbox
          label={
            <LuxTypography variant="textXs" fontSize={'0.875rem'}>
              {t('fieldsLabel.sameAsPatientDetails')}
            </LuxTypography>
          }
          onChange={e => handleContactDetailsForm(e)}
          // defaultChecked={checkboxValue}
          checked={checkboxValue}
        />
      </CheckBoxWrapper>
      <FormBuilderOb
        key={FormIds.ContactInformation}
        formIds={formIds}
        setEnableButton={setEnableButton}
        onUnmount={(formData: any) => {
          console.log('#formData.contactsDetails: ', formData.contactsDetails);
          updateContactDetils(formData.contactsDetails);
          setShouldSave(true);
        }}
        resetFieldsContactsDetails={checkboxValue}
        mykey="CONTACT_DETAILS"
      />
      {brandName && (
        <Box sx={{ padding: '0 1rem 1rem 1rem' }}>
          <LuxTypography fontFamily={theme.palette.LUX.obTokens.textSmFamily}>
            <span
              dangerouslySetInnerHTML={{
                __html:
                  t('contactDetailsPage.declaration', {
                    termsAndConditions: `<a href="${links?.termsAndConditions}" target="_blank" rel="noopener noreferrer" style="color:inherit;"><strong>${t('contactDetailsPage.termsAndConditions')}</strong></a>`,
                    privacyPolicy: `<a href="${links?.privacyPolicy}" target="_blank" rel="noopener noreferrer" style="color:inherit;"><strong>${t('contactDetailsPage.privacyPolicy')}</strong></a>`,
                  }) ?? '',
              }}
            ></span>
          </LuxTypography>
        </Box>
      )}
    </ContactDetailsWrapper>
  );
};

export default ContactDetailsPage;
